import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-row nowrap justify-content-between mb-3 heading" }
const _hoisted_2 = {
  key: 0,
  class: "my-3"
}
const _hoisted_3 = { class: "caption text-primary-green" }
const _hoisted_4 = {
  id: "email",
  class: "mb-3"
}
const _hoisted_5 = {
  key: 0,
  class: "mx-3 my-2"
}
const _hoisted_6 = {
  key: 1,
  class: "my-3"
}
const _hoisted_7 = { class: "caption text-primary-orange" }
const _hoisted_8 = { class: "my-4" }

import {
    reactive,
    computed,
    ComputedRef,
    ref,
    Ref,
    onMounted,
    onBeforeUnmount,
    onUnmounted,
    watch,
  } from 'vue'
  import scrollIntoView from 'smooth-scroll-into-view-if-needed'

  import TextInput from '@/components/LoginRegister/common/inputs/Text/v1/Text.vue'
  import FieldError from '@/components/LoginRegister/common/FieldError/v1/FieldError.vue'
  import Banner from '@/components/LoginRegister/common/Banner/v1/Banner.vue'
  import Button from '@/components/LoginRegister/common/Button/v1/Button.vue'
  import EyeSvg from '@/components/LoginRegister/svg/EyeSvg.vue'
  // import CheckSvg from '@/components/LoginRegister/svg/CheckSvg.vue'
  import EditSvg from '@/components/LoginRegister/svg/EditSvg.vue'

  import login_form_mandatory from '@/config/loginRegisterLegacy/login_form_mandatory.config'

  import useIsEmailValid from '@/composables/useIsEmailValid'

  import { onKeyStroke } from '@vueuse/core'

  import LoginForm from '@/model/Form/LoginForm'

  import * as _ from 'lodash'

  import login from '@/logic/contact/login'
  import useLoading, { isLoadingAny } from '@/composables/useLoading'
  import loginForm from '@/state/loginForm'

  import isPasswordIncorrect from '@/state/isPasswordIncorrect'
  import resetLoginForm from '@/logic/user-info/resetLoginForm'
  import { getQueryParams } from '@/utils'

  import { useI18n } from 'vue-i18n'

  interface Props {
    email: string
    isDisplayEmailSentMessage: boolean
    emailSentTo: string
  }
  interface Emits {
    (e: 'emailChange', email: string): void
    (e: 'resetPassword'): void
    (e: 'useOtherEmail'): void
  }

  // query params
  
export default /*@__PURE__*/_defineComponent({
  __name: 'LoginForm',
  props: {
    email: {},
    isDisplayEmailSentMessage: { type: Boolean },
    emailSentTo: {}
  },
  emits: ["emailChange", "resetPassword", "useOtherEmail"],
  setup(__props: any, { emit: __emit }) {

  const {t} = useI18n()

  const queryParams = getQueryParams()

  // state
  const state = reactive({
    isSeePassword: false,
    showErrors: false,
  })

  // computed
  const contentProcessed = computed(() => {
    return {
      email: `${t("loginRegister.contacts_email")}${
        login_form_mandatory.has('email') ? '*' : ''
      }`,
      password1: `${t("loginRegister.contacts_password1")}${
        login_form_mandatory.has('password') ? '*' : ''
      }`,
    }
  })
  const invalidFields = computed(() => {
    const invalidFields = new Set<string>()
    login_form_mandatory.forEach(field => {
      const fieldKey = field as keyof LoginForm
      if (!loginForm.value[fieldKey]) {
        invalidFields.add(field)
      }
    })
    if (!isEmailValid.value) invalidFields.add('email')
    return invalidFields
  })
  const email: ComputedRef<string> = computed(() => props.email)
  const isEmailValid: ComputedRef<boolean> = useIsEmailValid(email)

  // ref
  const passwordwrapper = ref()

  // props
  const props = __props

  // emit
  const emit = __emit

  // handlers
  const handleButtonClick = async () => {
    if (isLoadingAny.value) return

    if (invalidFields.value.size > 0) {
      state.showErrors = true
      const selector = `#${[...invalidFields.value][0]}`
      const invalidFieldElement = document.querySelector(
        selector
      ) as HTMLElement
      await scrollIntoView(invalidFieldElement, {
        // scrollMode: 'if-needed',
        ease: t => (t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t),
        duration: 750,
        block: 'center',
        inline: 'nearest',
      })
      return
    }
    state.showErrors = false

    const { startLoadingThis, stopLoadingThis } = useLoading()
    startLoadingThis()
    await login(loginForm.value)

    stopLoadingThis()
  }
  const handleEmailChange = (email: string) => {
    emit('emailChange', email)
  }
  const handlePasswordChange = (password: string) => {
    const formClone = _.cloneDeep(loginForm.value)
    formClone.password = password
    loginForm.value = formClone
  }
  const handleToggleSeePassword = () => {
    state.isSeePassword = !state.isSeePassword
  }
  const handleResetPassword = () => {
    emit('resetPassword')
  }
  const handleEditClick = () => {
    emit('useOtherEmail')
  }


  onMounted(async () => {
    await resetLoginForm()

    // onKeyStroke
    const stop = onKeyStroke('Enter', () => {
      handleButtonClick()
    })
    onBeforeUnmount(() => stop())

    passwordwrapper?.value?.querySelector('input')?.focus()
  })

  onUnmounted(() => {
    // Reset the error when unmounting
    isPasswordIncorrect.value = false
  })

  watch(
    () => props.email,
    () => {
      const formClone = _.cloneDeep(loginForm.value)
      formClone.email = props.email
      loginForm.value = formClone
    }
  )

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", null, _toDisplayString(_unref(t)('loginRegister.login')), 1)
    ]),
    (props.isDisplayEmailSentMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(Banner, { background: 'var(--green-100)' }, {
            text: _withCtx(() => [
              _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(t)('loginRegister.user_info_email_sent')) + " " + _toDisplayString(' ') + " " + _toDisplayString(props.emailSentTo), 1)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(TextInput, {
        id: 'email',
        disabled: true,
        value: props.email,
        placeholder: contentProcessed.value['email'],
        "container-box-border": 
          state.showErrors && invalidFields.value.has('email')
            ? '1px solid var(--primary-orange)'
            : undefined
        ,
        onInput: _cache[0] || (_cache[0] = newVal => handleEmailChange(newVal))
      }, {
        after: _withCtx(() => [
          (!invalidFields.value.has('email') && props.email)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(EditSvg, {
                  color: 'var(--primary-blue)',
                  role: "button",
                  onClick: _withModifiers(handleEditClick, ["stop"])
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["value", "placeholder", "container-box-border"]),
      (state.showErrors && invalidFields.value.has('email'))
        ? (_openBlock(), _createBlock(FieldError, {
            key: 0,
            class: "my-1",
            ref: "email-error"
          }, {
            default: _withCtx(() => [
              (!props.email)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_unref(t)('loginRegister.user_info_mandatory_field')), 1)
                  ], 64))
                : (!_unref(isEmailValid))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(" Email is not valid ")
                    ], 64))
                  : _createCommentVNode("", true)
            ]),
            _: 1
          }, 512))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      id: "password",
      ref_key: "passwordwrapper",
      ref: passwordwrapper,
      class: "mb-3"
    }, [
      _createVNode(TextInput, {
        id: 'password',
        value: _unref(loginForm).password,
        placeholder: contentProcessed.value['password1'],
        "input-type": state.isSeePassword ? 'text' : 'password',
        "container-box-border": 
          state.showErrors && invalidFields.value.has('password')
            ? '1px solid var(--primary-orange)'
            : undefined
        ,
        onInput: _cache[2] || (_cache[2] = newVal => handlePasswordChange(newVal))
      }, {
        after: _withCtx(() => [
          (_unref(loginForm).password)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                role: "button",
                onClick: _cache[1] || (_cache[1] = () => handleToggleSeePassword()),
                class: "mx-3 my-2"
              }, [
                _createVNode(EyeSvg, {
                  opacity: state.isSeePassword ? 1 : 0.5,
                  color: 'var(--primary-blue)'
                }, null, 8, ["opacity"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["value", "placeholder", "input-type", "container-box-border"]),
      (state.showErrors && invalidFields.value.has('password'))
        ? (_openBlock(), _createBlock(FieldError, { key: 0 }, {
            default: _withCtx(() => [
              (!_unref(loginForm).password)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_unref(t)('loginRegister.user_info_mandatory_field')), 1)
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ], 512),
    _createElementVNode("div", {
      class: "my-3 link-small text-primary-blue",
      role: "button",
      onClick: _cache[3] || (_cache[3] = _withModifiers(() => handleResetPassword(), ["stop"]))
    }, [
      _createElementVNode("span", null, [
        _createElementVNode("u", null, _toDisplayString(_unref(t)('loginRegister.user_info_forgot_password')), 1)
      ])
    ]),
    (_unref(isPasswordIncorrect))
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(Banner, { background: 'var(--orange-100)' }, {
            text: _withCtx(() => [
              _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(t)('loginRegister.contacts_incorrect_credentials')), 1)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(Button, {
        disabled: state.showErrors && invalidFields.value.size > 0,
        class: "p-3",
        onButtonClick: handleButtonClick
      }, {
        text: _withCtx(() => [
          _createElementVNode("span", null, _toDisplayString(_unref(t)('loginRegister.validate')), 1)
        ]),
        _: 1
      }, 8, ["disabled"])
    ])
  ]))
}
}

})